'use strict';

function CompanyAddressBookService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/contacts/:contactId', { }, {
    'update': {
      method: 'PUT'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyAddressBookService', [
    '$resource',
    'config',
    CompanyAddressBookService
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanyAddressBookService.js
// module id = 56
// module chunks = 0